import * as modules from '@/modules';
import { Logger } from '@/mixins';

let resolvePromise = null;

export const modulesLoaded = new Promise((resolve) => (resolvePromise = resolve));

export const loadModules = () => {
	let promises = Object.entries(modules).map(([key, factory]) => {
		return new Promise((resolve, reject) => {
			const instances = factory();

			resolve({
				key,
				instances
			});
		});
	});

	return Promise.all(promises).then((entries) => {
		const instanceLookup = entries
			.filter((entry) => entry?.instances?.filter?.(Boolean).length)
			.reduce((prev, entry) => {
				prev[entry.key] = new Map();

				entry.instances.forEach((instance) => {
					const node = instance.elNode || instance.node || instance?.$node?.[0];
					if (!node) return;

					prev[entry.key].set(node, instance);
				});

				return prev;
			}, {});

		Object.defineProperty(instanceLookup, 'getModule', {
			value: (name) => {
				if (!Object.keys(instanceLookup).includes(name)) {
					Logger.error(`Module ${name} does not exist or does have any instances.`);
					return null;
				} else {
					return instanceLookup[name];
				}
			}
		});

		resolvePromise(instanceLookup);

		return entries;
	}).catch((error) => {
		Logger.error(error);
	});
};
